import { DownloadReportsRepository } from "@adapters/repositories/Reports/common/downloadrepo";
import { accountDetails } from "@di";
import { EdelFileSaver } from "@frameworks/web/di/FIleSaver";
export default (http) => ({
    downloadReportsRepo: new DownloadReportsRepository(http, new EdelFileSaver(), accountDetails),
});
